import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cx } from '../cx';
const Root = t0 => {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("grid animate-pulse", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const Item = t0 => {
  const $ = _c(5);
  const {
    className,
    lines: t1
  } = t0;
  const lines = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== lines) {
    t2 = Array.from({
      length: lines
    });
    $[0] = lines;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = <>{t2.map((_, index) => <div key={index} className={cx("rounded-xl bg-sand", className)} />)}</>;
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};

/**
 * @deprecated Use Skeleton from @7f-ui instead
 */
export const Skeleton_OLD = Object.assign(Root, {
  Item
});